module.exports = __webpack_public_path__ + "img/excel.971dccb9.svg";